import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Joyride } from 'react-joyride';
import { getJoyrideScrollOffset } from 'utils/joyrideConfig';
import BuscadorSinBajaPendiente from "components/blocks/Searchers/Delta/BuscadorSinBajaPendiente";
import BuscadorSinBajaRemesada from "components/blocks/Searchers/Delta/BuscadorSinBajaRemesada";
// import GridDeltaAccidentWithoutLeave from "components/blocks/Grids/GridDeltaAccidentWithoutLeave";
import ResultadoBusquedaDeltas from "components/blocks/ResultadoBusquedaDeltas/ResultadoBusquedaDeltas";
import PageMenu from "../../blocks/PageMenu/PageMenu";
import useAllRatsb from "services/delta/ratsb/useAllRatsb";
import IconArrowGray from "../../../img/icons/svg/botones/flecha-big-gris.svg";
import { TextMessagesTemplates } from "components/blocks/TextMessagesTemplates/TextMessagesTemplates";
import { clearFechaCNAE } from '../../../services/utils/fechaCNAEUtils';
import useDeltaStore from 'stores/useDeltaStore';
import moment from 'moment';
import { useDeltaSearchTour } from 'hooks/useDeltaSearchTour';
import 'components/blocks/Searchers/Delta/DeltaSearchLayout.scss';

const DeltaWithoutLeave: React.FC = () => {
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [isRemitted, setIsRemitted] = useState<null | boolean>(null);

  const allFilterRatsb             = useDeltaStore((s) => s.allFilterRatsb);
  const setAllFilterRatsb          = useDeltaStore((s) => s.setAllFilterRatsb);
  const setRatsbFilterValues       = useDeltaStore((s) => s.setRatsbFilterValues);
  const allFilterRatsbRemesed      = useDeltaStore((s) => s.allFilterRatsbRemesed);
  const setAllFilterRatsbRemesed   = useDeltaStore((s) => s.setAllFilterRatsbRemesed);
  const setRatsbRemesedFilterValues = useDeltaStore((s) => s.setRatsbRemesedFilterValues);

  const title = location?.pathname.includes("remesados")
    ? "Accidentes sin baja Delta remesados"
    : "Accidentes sin baja pendientes de delta";
  const breadcrumbs = [
    "unidad delta",
    location?.pathname.includes("remesados")
      ? "Accidentes sin baja Delta remesados"
      : "Accidentes sin baja pendientes de delta",
  ];

  const { getAllRatsbByUser, getCompleteRatsbByUserRemesed } = useAllRatsb();

  const handleFilterRatsb = async (values: any) => {
    const sendData: any = {
      validacion: parseInt(values.validation) || null,
      remesado: parseInt(values.remesados) || null,
      fechaAccidenteDesde: values.FromDate
        ? moment(values.FromDate, 'DD/MM/YYYY').startOf('day').format('YYYY-MM-DD')
        : null,
      fechaAccidenteHasta: values.ToDate
        ? moment(values.ToDate, 'DD/MM/YYYY').endOf('day').format('YYYY-MM-DD')
        : null,
      trabajador: values.name || null,
      cnaeCodigo: values.cnaeCode || null,
      empresa: values.company || null,
      empresasId: values.companyCif || null,
    };
    setLoading(true);
    setError(false);
    const response = await getAllRatsbByUser(sendData);
    if (response) {
      setAllFilterRatsb(response);
      setRatsbFilterValues(values);
      setLoading(false);
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilterRatsbRemesed = async (values: any) => {
    const sendData: any = {
      fechaAccidenteDesde: values.FromDate
        ? moment(values.FromDate, 'DD/MM/YYYY').startOf('day').format('YYYY-MM-DD')
        : null,
      fechaAccidenteHasta: values.ToDate
        ? moment(values.ToDate, 'DD/MM/YYYY').endOf('day').format('YYYY-MM-DD')
        : null,
      trabajador: values.name || null,
      cnaeCodigo: values.cnaeCode || null,
      empresa: values.company || null,
      empresasId: values.companyCif || null,
      aceptado:
        typeof values.deltaPart === "string"
          ? JSON.parse(values.deltaPart.toLowerCase())
          : null,
    };
    setLoading(true);
    setError(false);
    const response = await getCompleteRatsbByUserRemesed(sendData);
    if (response) {
      setAllFilterRatsbRemesed(response);
      setRatsbRemesedFilterValues(values);
      setLoading(false);
    } else {
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    setIsRemitted(location.pathname.includes("remesados"));
  }, [location]);

  useEffect(() => {
    clearFechaCNAE();
  }, []);

  const hasResults = isRemitted
    ? !!allFilterRatsbRemesed
    : !!allFilterRatsb;

  const { run, tourKey, steps, handleCallback, startTour } = useDeltaSearchTour(hasResults);

  useEffect(() => {
    const handler = () => startTour();
    window.addEventListener('solimat:startDeltaSearchTour', handler);
    return () => window.removeEventListener('solimat:startDeltaSearchTour', handler);
  }, [startTour]);

  const JOYRIDE_PROPS = {
    continuous: true, scrollToFirstStep: true,
    locale: { back: 'Anterior', close: 'Cerrar', last: 'Finalizar', next: 'Siguiente', nextWithProgress: 'Siguiente ({current} de {total})', open: 'Iniciar tour de ayuda', skip: 'Omitir tour' },
    options: { primaryColor: '#0F1F3D', zIndex: 10000, overlayColor: 'rgba(15,47,73,0.45)', showProgress: true, buttons: ['back','skip','close','primary'] } as any,
    styles: { beaconInner: { backgroundColor: '#F97316' }, beaconOuter: { borderColor: '#F97316', backgroundColor: 'rgba(249,115,22,0.2)' }, tooltip: { borderRadius: 8, fontSize: 14 }, tooltipTitle: { fontSize: 15, fontWeight: 700, textAlign: 'left' as const }, tooltipContent: { textAlign: 'left' as const } },
  };

  return (
    <>
      <Joyride
        key={tourKey}
        steps={steps}
        run={run}
        onEvent={handleCallback}
        {...JOYRIDE_PROPS}
        options={{
          ...JOYRIDE_PROPS.options,
          scrollOffset: getJoyrideScrollOffset(),
        }}
      />
      <PageMenu title={title} breadcrumbs={breadcrumbs}>
        <div className="btns-header-container">
          <Link to="/unidad-delta">
            <img src={IconArrowGray} alt="icon arrow right" />
          </Link>
        </div>
      </PageMenu>

      <section>
        <div className="container">
          <div className="delta-search-layout">

            {/* ── Sidebar buscador ── */}
            <aside className="delta-search-sidebar">
              <div className="delta-search-sidebar__head">
                <span className="delta-search-sidebar__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
                  </svg>
                </span>
                <h3 className="delta-search-sidebar__title">
                  {isRemitted ? "Buscador Relación Sin Baja Remesada" : "Buscador de Relación Sin Baja"}
                </h3>
              </div>

              {isRemitted !== null && (
                isRemitted ? (
                  <BuscadorSinBajaRemesada
                    handleFilterRatsbRemesed={handleFilterRatsbRemesed}
                    loading={loading}
                  />
                ) : (
                  <BuscadorSinBajaPendiente
                    handleFilterRatsb={handleFilterRatsb}
                    loading={loading}
                  />
                )
              )}
            </aside>

            {/* ── Área de resultados ── */}
            <main className="delta-search-content">
              {loading && (
                <div className="mt-4">{TextMessagesTemplates.loading}</div>
              )}
              {error && (
                <div className="mt-4">{TextMessagesTemplates.errorResponse}</div>
              )}

              {!loading && !hasResults && (
                <div className="delta-search-placeholder">
                  <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
                  </svg>
                  <p>Usa el buscador para encontrar accidentes sin baja.</p>
                </div>
              )}

              {!isRemitted && allFilterRatsb && !loading && (
                // {/* <GridDeltaAccidentWithoutLeave data={allFilterRatsb} isRemitted={isRemitted} /> */}
                <ResultadoBusquedaDeltas
                  arrData={allFilterRatsb}
                  type="withoutLeave"
                  isRemitted={false}
                />
              )}
              {isRemitted && allFilterRatsbRemesed && !loading && (
                // {/* <GridDeltaAccidentWithoutLeave data={allFilterRatsbRemesed} isRemitted={isRemitted} /> */}
                <ResultadoBusquedaDeltas
                  arrData={allFilterRatsbRemesed}
                  type="withoutLeave"
                  isRemitted={true}
                />
              )}
            </main>

          </div>
        </div>
      </section>
    </>
  );
};

export default DeltaWithoutLeave;
